import * as React from 'react';
import OutlinedInput from '@mui/material/OutlinedInput';
import PropTypes from 'prop-types';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';

function SingleSelect(props) {
  const { items, onChange, value, name, label, disabled, shrink } = props;

  const labelId = `${name}-label`;

  return (
    <FormControl fullWidth size="small">
      {label && (
        <InputLabel id={labelId} shrink={shrink}>
          {label}
        </InputLabel>
      )}
      <Select
        labelId={labelId}
        displayEmpty
        value={value}
        name={name}
        onChange={onChange}
        input={<OutlinedInput label={label} />}
        disabled={disabled}
      >
        {items.map((item) => (
          <MenuItem key={item.value} value={item.value}>
            {item.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

SingleSelect.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    }),
  ).isRequired,
  value: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string,
  disabled: PropTypes.bool,
  shrink: PropTypes.bool,
};

SingleSelect.defaultProps = {
  label: null,
  disabled: false,
  shrink: undefined,
};

export default SingleSelect;
